import { requestBuilder } from '../../http/RequestBuilder';
import type { InterestNotificationTotalsResponseDto } from './types';

export const useGetInterestNotificationTotals = requestBuilder.query<
    InterestNotificationTotalsResponseDto,
    { date: string },
    Error
>({
    endpoint: ({ date }) =>
        `/api/admin/bank-ops/interest-notification-totals/${date}`,
    queryKey: ({ date }) =>
        `/api/admin/bank-ops/interest-notification-totals/${date}`,
});
